export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/caret-up-d698e72c4416e37f5601fd97bd748531.svg";